import { useNavigate, useParams } from 'react-router';
import { useEffect } from 'react';
import api from '@/api/api';
import { showToast } from '@/components/ToastManager';

function VerifyAssistantInviteToken() {
  const { assistantInviteToken } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function getMeetingByAssistant(assistantInviteToken: string) {
      const meetingUid = await api.getMeetingByAssistant(assistantInviteToken);
      if (meetingUid) {
        navigate(`/meeting/${meetingUid}`, {
          state: { assistant_invite_token: assistantInviteToken }
        });
      } else {
        showToast(
          'errorToast',
          'error',
          'Неправильная ссылка',
          'Запросите приглашение у преподавателя еще раз'
        );
      }
    }
    if (assistantInviteToken) {
      getMeetingByAssistant(assistantInviteToken);
    }
  }, [assistantInviteToken]);

  return <></>;
}

export default VerifyAssistantInviteToken;
